
// Events.jsx

import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./UserCalender.css";

const Events = () => {
  const [date, setDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API_URL}/api/events`);
      const data = await res.json();

      setEvents(data);

      const today = formatDate(new Date());

      const todayEvents = data.filter(
        (event) => event.event_date?.split("T")[0] === today
      );

      setSelectedEvents(todayEvents);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleDateClick = (value) => {
    setDate(value);

    const selectedDate = formatDate(value);

    const filtered = events.filter(
      (event) =>
        event.event_date?.split("T")[0] === selectedDate
    );

    setSelectedEvents(filtered);
  };

  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;

    const currentDate = formatDate(date);

    const hasEvent = events.some(
      (event) =>
        event.event_date?.split("T")[0] === currentDate
    );

    return hasEvent ? <div className="event-dot"></div> : null;
  };

  return (
    <div className="events-page">

      {/* Header */}
      <div className="events-header">
        <span className="events-header-icon">📅</span>

        <h1>Library Events</h1>

        <p>
          Stay updated with upcoming library events,
          workshops and book fairs.
        </p>
      </div>

      {/* Main Content */}
      <div className="events-content">

        {/* Calendar */}
        <div className="calendar-card">

          <div className="calendar-heading">
            <div>
              <h2>Event Calendar</h2>
              <p>Select a date to view events</p>
            </div>

            <span>📆</span>
          </div>

          <Calendar
            onChange={handleDateClick}
            value={date}
            tileContent={tileContent}
          />

          <div className="calendar-note">
            <span className="event-dot legend-dot"></span>
            <span>Date has an event</span>
          </div>

        </div>

        {/* Event Details */}
        <div className="events-card">

          <div className="events-card-header">
            <div>
              <h2>Events on</h2>

              <strong>
                {date.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </strong>
            </div>

            <div className="date-icon">
              📅
            </div>
          </div>

          <div className="events-list">

            {selectedEvents.length > 0 ? (
              selectedEvents.map((event) => (
                <div
                  key={event.event_id}
                  className="event-card"
                >
                  <div className="event-icon">
                    📖
                  </div>

                  <div className="event-info">
                    <h3>{event.title}</h3>

                    <p>
                      {event.description ||
                        "No description available."}
                    </p>

                    <div className="event-date">
                      📅{" "}
                      {event.event_date?.split("T")[0]}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-events">

                <div className="no-events-icon">
                  📅
                </div>

                <h3>No Events</h3>

                <p>
                  There are no library events scheduled
                  for this date.
                </p>

              </div>
            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default Events;